import {
  Controller
} from "@hotwired/stimulus"
import Choices from "choices.js"
import "choices.js/public/assets/styles/choices.css"
import {
  debugLog
} from '../debug'

export default class extends Controller {
  static targets = ["select"]
  static values = {
    initialsupplier: Array
  }

  connect() {
    this.connectChoices()
  }

  reconnectChoices() {
    const that = this
    const newChoices = Array.from(this.selectTarget.options).map(option => ({
      value: option.value,
      label: option.textContent,
      selected: that.initialsupplierValue.includes(option.value)
    }));
    this.connectChoices()
    this.selectTarget.choices.setChoices(newChoices, 'value', 'label', true, true)
  }

  connectChoices() {
    const element = this.selectTarget
    if (element.choices != undefined) {

      this.selectTarget.choices.destroy()
      this.selectTarget.choices.clearStore();
    }

    element.choices = new Choices(element, {
      removeItemButton: true,
      duplicateItemsAllowed: false,
      searchEnabled: false,
      shouldSort: true,
      shouldSortItems: true,
      itemSelectText: ''
    })
  }
}